import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import { statsEn, statsFr } from "../about/utils";

const Compliance = () => {
  const { t } = useTranslation("home");
  const language = localStorage.getItem("selectedLanguage");

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const stats = language?.includes("fr") ? statsFr : statsEn;
  return (
    <div
      className="flex flex-col items-center w-full h-full md:mt-[10rem] xl:mt-20 mb-10"
      ref={ref}
    >
      <div className="flex justify-center items-center w-[95%] flex-col">
        <div className="mb-[2rem] md:mb-[6rem] flex justify-center items-center md:w-[80%] xl:w-[58%]">
          <h1 className="text-[36px] md:text-[48px] font-medium text-center capitalize leading-[62px]">
            {t("compliance")}
          </h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-5 w-full">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className={`flex justify-center items-center flex-col w-full md:w-64.25  ${idx === 1 ? "bg-[#202D66]" : ""} h-[178px]`}
            >
              <h6
                className={`text-[40px] md:text-[32px] ${idx === 1 ? "text-white" : "text-black"}`}
              >
                {inView ? <CountUp end={stat.value} /> : 0}
                {stat.suffix}
              </h6>
              <p
                className={` font-light text-base md:text-[20px] w-fit text-center capitalize ${idx === 1 ? "text-[#FFFFFFCC]" : "text-[#00000080]"} w-[60%]`}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
const CountUp = ({ end, duration = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 16); // ~60fps
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [end, duration]);

  // Format numbers with commas
  const formattedCount =
    end >= 1000 ? count.toLocaleString() : count.toString();

  return <span>{formattedCount}</span>;
};

export default Compliance;
